import script from "./Button.vue?vue&type=script&setup=true&lang=js"
export * from "./Button.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__